import React from 'react';

import { ForecasterAccountInputsProvider } from '../account/context/ForecasterAccountInputsContext';
import { ForecasterAccountProjectionProvider } from '../account/context/ForecasterAccountProjectionContext';

type Props = {
  accountId?: string;
  children: React.ReactNode;
};

export const ForecasterAccountProvider: React.FC<Props> = ({ accountId, children }) => {
  if (!accountId) return children;

  return (
    <ForecasterAccountInputsProvider accountId={accountId}>
      <ForecasterAccountProjectionProvider accountId={accountId}>{children}</ForecasterAccountProjectionProvider>
    </ForecasterAccountInputsProvider>
  );
};
